import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { get } from "../../util/axiosLib";
import ls from "util/secureStorage";
import constant from "config/constant";
import { wrapBaseApi } from "util/apiWrapper";

const getToken = () => ls.get(constant.AUTH_TOKEN_KEY).token;

const getHeaders = (token = null) => ({
  authorization: token ?? getToken(),
  "Content-Type": "application/json",
});

const initialState = {
  status: "idle",
  profile: {},
};

export const fetchUserProfile = createAsyncThunk(
  "profile/fetchUserProfile",
  async () => {
    const response = await get(
      wrapBaseApi(`/auth/currentUser`),
      getHeaders()
    );

    // const userData = JSON.parse(localStorage.getItem("btm_user"));
    // console.log("PROFILE RESPONSE", response.data);
    return response.data;
  }
);

const profileSlice = createSlice({
  name: "profile",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(fetchUserProfile.fulfilled, (state, { payload }) => {
      state.status = "success";
      state.profile = payload.data;
      // state.profile.country = "Ghana";
    });
    builder.addCase(fetchUserProfile.pending, (state, action) => {
      state.status = "fetching";
    });
    builder.addCase(fetchUserProfile.rejected, (state, action) => {
      state.status = "error";
    });
  },
});

export const selectProfile = (state) => state.profile;

export const { actions, reducer: ProfileReducer } = profileSlice;
